export default __webpack_public_path__ + "static/media/labelline.9c6cbb36.png";